import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type Props = {};

const Notification = ({}: Props) => {
  return (
    <ToastContainer
      position="bottom-right"
      pauseOnFocusLoss={false}
      limit={3}
      draggablePercent={50}
    />
  );
};

export default Notification;
